import React from 'react';
import { Link } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { useCart } from '../../context/CartContext';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart(product);
  };

  return (
    <Link
      to={`/product/${product.slug}`}
      className="group flex flex-col bg-white rounded-2xl overflow-hidden border border-dark-100 hover:border-athletic-200 shadow-soft hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300"
    >
      <div className="aspect-square bg-dark-50 relative overflow-hidden">
        <img src={product.image} alt={product.name} loading="lazy" className="w-full h-full object-contain p-6 group-hover:scale-105 transition-transform duration-500" />
        {product.badge && (
          <span className="absolute top-3 left-3 px-2.5 py-1 text-[11px] font-semibold rounded-md bg-white/90 backdrop-blur text-dark-700 border border-dark-100">{product.badge}</span>
        )}
      </div>
      <div className="p-5 flex flex-col flex-grow border-t border-dark-100">
        <p className="text-[11px] font-medium uppercase tracking-[0.16em] text-athletic-600 mb-1.5">{product.categorySlug?.replace(/-/g, ' ')}</p>
        <h3 className="font-display text-[17px] font-semibold text-dark-900 mb-4 group-hover:text-athletic-600 transition-colors line-clamp-2 flex-grow leading-snug">{product.name}</h3>
        <div className="flex items-center justify-between mt-auto">
          <p className="text-xl font-bold text-dark-900">${product.price.toFixed(2)}</p>
          <span onClick={handleAddToCart} className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-lg border border-dark-200 text-sm font-semibold text-dark-800 group-hover:bg-athletic-600 group-hover:border-athletic-600 group-hover:text-white transition-all">
            <Plus className="w-4 h-4" /> Add
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;
